/*
 * @Description:头条号待编渠道路由
 * @Author: he.jianbo
 * @LastEditors: he.jianbo
 * @Date: 19-11-03
 * @LastEditTime: 2019-11-12 19:13:39
 */
'use strict';
angular.module('editToutiaohaoToBeCompiledRouterModule', []).config([
    '$stateProvider',
    '$urlRouterProvider',
    function($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('front.editctr.toutiaohao.waitcompiled', {
                url: '/waitcompiled?account&isOriginal', // accountid->账号
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/toutiaohao/toBeCompiled/main.html',
                        controller: 'EditToutiaohaoToBeCompiledCtrl',
                    },
                },
            })
            .state('toutiaohaonews', {
                // account:头条账号
                // articleid:头条文章ID
                // isOriginal：是否原创
                // toutiaohaoplatform:区分待编待审，0为待编，1为待审
                // iwochnldocid：融合编辑稿件ID
                // isawaitrevise 是否为修订稿件
                url: '/toutiaohaonews?account&articleid&isOriginal&platform&iwochnldocid&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/toutiaohao/toBeCompiled/news/toutiaohao_news.html',
                        controller: 'editingCenterToutiaohaoNewsCtrl',
                    },
                },
            })
            .state('toutiaohaovideo', {
                url: '/toutiaohaovideo?account&articleid&isOriginal&platform&iwometadataid&isawaitrevise',
                views: {
                    '': {
                        templateUrl: './editingCenter/toutiaohao/toBeCompiled/video/toutiaohaoVideo.html',
                        controller: 'editingCenterToutiaohaoVideoCtrl',
                    },
                },
            });
    },
]);
